module.exports = __webpack_public_path__ + "f53d7eba3904e7a837d19b036b3d4097.png";